<form [formGroup]="frmGroup">
  <div class="custom-control custom-switch">
    <hcc-custom-validation [validations]="fieldInfo.validation">
      <input
        type="checkbox"
        [checked]="value"
        class="custom-control-input"
        [formControlName]="control"
        acCheckbox
        [fieldInfo]="fieldInfo"
        (change)="change($event.currentTarget.checked)"
      />
    </hcc-custom-validation>
    <label
      *ngIf="fieldInfo.showLabel"
      [fieldInfo]="fieldInfo"
      class="custom-control-label"
      acForLable
    >
      {{ fieldInfo.label }}<span *ngIf="fieldInfo.validation?.required">*</span>
    </label>
  </div>
</form>
